import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson, getErrMsg } from '../service/serviceUtil';

import ContextualMessage from '../components/contextualMessage';

class DemandeIdentifiant extends Component {
    constructor(props) {
        super(props)

        this.field = null;

        this.state = {
            username: "",
            error: null,
            typeMsg: null, 
            txtMsg: null, 
            errorApi: false
        }
    }

    get labels() {
        return chainesLocales['DemandeIdentifiant'][this.props.lang];
    }

    componentDidMount() {
        this.field.focus();
    }
    
    componentDidUpdate(oldProps, oldState) {
        //Sélectionner et focuser sur le champ de saisie en cas d'erreur au submit
        if (!oldState.error && this.state.error && this.state.username === oldState.username) {
            this.field.focus();
            this.field.select();
        }
    }

    render() {
        return (
            <form className="text-left" method="GET" onSubmit={this.onSubmit.bind(this)}>
                <h1>{this.labels.title}</h1>
                <div className="mb-3 text-justify" dangerouslySetInnerHTML={{ __html: this.props.config[`MES_ID_${this.props.lang}`] }}></div>
                {
                    this.state.error ? <ContextualMessage type="error" showIcon={false} content={getErrMsg(this.state.error, this.props.lang)} /> : null
                }
                {
                    this.state.txtMsg ? <ContextualMessage type={this.state.typeMsg} showIcon={false} content={this.state.txtMsg} /> : null
                }
                {
                    this.state.errorApi ? <ContextualMessage type="error" showIcon={false} content={chainesLocales['ErrApi'][this.props.lang].msg} /> : null
                }
                <div className="form-group">
                    <label htmlFor="username" className={this.state.error && this.state.error.code === 10 ? 'is-invalid' : ''} style={{ fontSize: "1.1rem" }}>{this.labels.labelIdent}</label>
                    <input ref={(e) => this.field = e} className={`form-control ${this.state.error && this.state.error.code === 10 ? 'is-invalid' : ''}`} id="username" type="text" autoCapitalize="off" maxLength={9} size={9} style={{ width: 120 }} value={this.state.username} onChange={this.onChange.bind(this)} />
                    <div className="invalid-feedback">{this.labels.invalidMsgIdent}</div>
                </div>
                <div>
                    <button className="btn btn-primary" type="submit" disabled={this.state.username.length === 0}><span className="label">{this.labels.button}</span><span className="spinner"></span></button>
                </div>
            </form>
        )
    }

    onSubmit(e) {
        e.preventDefault();

        if (document.querySelector) {
            document.querySelector('button[type="submit"]').disabled = true;
            if (document.body.classList) document.querySelector('button[type="submit"]').classList.add('loading');
        }

        let defaultParams = {
            lang: this.props.lang,
            suffixe: this.props.suffixe
        };

        let formData = new FormData();
        formData.append( "username", this.state.username.trim());

        let fetchOptions = {
            method: "POST",
            credentials: "same-origin",
            body: formData
        };

        getJson('user', defaultParams, fetchOptions).then(userData => {
            if (userData.error || userData.message) {
                this.setState({ error: userData.error, typeMsg: userData.type, txtMsg: userData.message, errorApi: false }, () => {
                    if (document.querySelector) {
                        document.querySelector('button[type="submit"]').disabled = false;
                        if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                    }
                });
            } else {
                this.props.onPageSuccess({ user: userData });
            }
        }).catch(err => {
            console.error("Erreur API identifiant: " + err);

            this.setState({ errorApi: true, error: null, typeMsg: null, txtMsg: null }, () => {
                if (document.querySelector) {
                    document.querySelector('button[type="submit"]').disabled = false;
                    if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                }
            });
        });
    }

    onChange(e) {
        this.setState({ username: e.target.value.trim() });
    }
}

export default DemandeIdentifiant